import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AppRouter, { history } from './routers/AppRouter';
import configureStore from './store/configureStore';
import 'leaflet/dist/leaflet.css';
import 'normalize.css/normalize.css';
import 'antd/dist/antd.css';
import loadFont from './font/loadFonts';
import './styles/styles.scss';
import defaultState from './data/state';
import {getRoute} from './routers/RouterMap';
import {chartPlugin} from './chart/plugin';

import {startSetResponse, startSetResponseForecast, startSetResponseEconomicModel} from './actions/globalState';

import LoadingPage from './components/LoadingPage';
import { PersistGate } from 'redux-persist/integration/react'
import ReactGA from 'react-ga';
import  ErrorPage from './components/ErrorPage'

const {store,persistor}  = configureStore();
if (window.location.href.includes('brisbane.geografia.com.au')) {
  //PROD GA account
  ReactGA.initialize('UA-86661193-4');
} else {
  // TEST GA account
  ReactGA.initialize('UA-86661193-5');
}
ReactGA.pageview(window.location.pathname + window.location.search);
const jsx = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppRouter />
      
    </PersistGate>
  </Provider>
);

let hasRendered = false;


const renderApp = (error) => {
  //console.log('state in reder app', error)
  if (error) {
    ReactDOM.render(<ErrorPage />, document.getElementById('app'));
    hasRendered = true;
  }
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById('app'));
    hasRendered = true;
  }
};
ReactDOM.render(<LoadingPage />, document.getElementById('app'));

//initilize chart plugin to set up background chart color
chartPlugin()

const state = store.getState();
if(history.location.pathname === '/economicmodel' || history.location.pathname === '/economicmodeldashboard') {

  store.dispatch(
    startSetResponseEconomicModel(getRoute(history.location.pathname))
  )
  renderApp()
  if(state.auth.isLoggedin) {
    history.push('/economicmodeldashboard');
  } else {
    history.push('/economicmodel');
  }
} else if(history.location.pathname === '/populationforecast') {
  //console.log('store', store.getState(), 'history.location.pathname', history.location.pathname,  getRoute(history.location.pathname))
  store.dispatch(
    startSetResponseForecast(getRoute(history.location.pathname))
  ).then(()=> {
    renderApp();
  }).catch(error => {
    renderApp({error: true});
  });
  history.push(history.location.pathname);
} else {
  //console.log('store', store.getState(), 'history.location.pathname', history.location.pathname,  getRoute(history.location.pathname))
  store.dispatch(
    startSetResponse(defaultState.geo_type, defaultState.geo_name, getRoute(history.location.pathname))
  ).then(()=> {
    renderApp();
  }).catch(error => {
    renderApp({error: true});
  });
  history.push(history.location.pathname);
} 




// WEBPACK FOOTER //
// ./src/app.js